<script setup lang="ts">
import { GrammarIcon } from '@nora-monorepo/grammar-ui';

import { mapCrosshairIcon } from '#nora-ui/types/icon-constants';
</script>

<template>
  <div
    class="absolute inset-0 flex items-center justify-center pointer-events-none z-30"
  >
    <GrammarIcon
      size="small"
      :icon-template="mapCrosshairIcon"
    />
  </div>
</template>
